module.exports = __webpack_public_path__ + "static/media/Articles 12.f44c7f70.svg";